module.exports = __webpack_public_path__ + "static/media/xero-connected-colour.87503953.svg";